import {getPriceFormat} from "@/utils/global-functions";
import Link from "next/link";

export default function ServicePackageCard({data = {}, link = "", holiday}) {

    const {
        title = "",
        subtitle = "",
        service_feature = "",
        base_price = 0,
        delivered_in = 0,
        elements = [],
        color = "",
        metric_unit = "",
        pricing_method = 0,
    } = data;

    return (
        <div
            className="relative flex flex-col border-[0.188rem] border-pol-gray-light-8 rounded-[2.25rem] pt-[1.875rem] pb-6 px-[1.875rem] text-center hover:shadow-[0_9px_12px_4px_rgba(143,136,166,0.12)] duration-300">
            <span className="w-[81%] h-2 absolute top-0 left-[9.5%] rounded-b-xl" style={{backgroundColor: color}}/>
            <p className="text-pol-dark font-bold text-xl">{title}</p>
            <p className="text-pol-gray-600 font-semibold text-lg mt-2.5">{subtitle}</p>
            <p className="text-pol-gray-375 font-semibold text-sm mt-2.5">{service_feature}</p>
            <p className="text-pol-gray-525 font-semibold text-xs mt-7">{pricing_method ? `قیمت هر ${metric_unit}` : "شروع قیمت از"}</p>
            <div className="flex-center text-pol-dark-800 font-bold rounded-3xl bg-pol-light-9 py-3.5 px-1 mt-1.5">
                <span className="text-[1.75rem]">{getPriceFormat(base_price)}</span>
                <span className="mr-2.5 text-sm">تومان</span>
            </div>
            <ul className="text-pol-gray-600 mt-5 text-[0.938rem]">
                {
                    elements.map((item, index) => (
                        <li key={index}
                            className="border-b border-b-pol-light-9 py-3">
                            {item.title || item.text}
                        </li>
                    ))
                }
                <li className="border-b border-b-pol-light-9 py-3">تحویل در {delivered_in} روز </li>
            </ul>
            <p className="mt-3 mb-5 text-[0.938rem] font-semibold">امکان چت آنلاین با فریلنسر</p>
            {
                holiday ?
                    <button className="text-center w-full rounded-[0.813rem] mt-auto py-2.5 font-semibold bg-pol-gray-light text-pol-gray-dark cursor-not-allowed">
                        تعطیلات هستم
                    </button> :
                    <Link
                        href={link}
                        style={{backgroundColor: color}}
                        className="block text-center w-full text-white rounded-[0.813rem] mt-auto py-2.5 font-semibold">
                        جزئیات و ثبت سفارش
                    </Link>
            }

        </div>
    )
}
